import { WindowContext } from "./window.context";

export enum WindowActionTypes {
    Loaded = 0,
    Saved = 1,
    Close = 2,
    NavigateToMember = 3,
}

export enum WindowTypes {
    License = 0,
    EditMember = 1,
    Ticket = 2,
    Email = 3,
    Note = 4,
    TicketAdd = 20,
}

export class WindowEvent {
    ID: string;
    WindowType: WindowTypes
    ActionType: WindowActionTypes;
    Data: any;
    Result: boolean;
    Message: string;

    public static FromWindowContext(context: WindowContext<any>): WindowEvent {

        let event = new WindowEvent();
        event.ID = context.ID;
        event.WindowType = context.WindowType;

        return event;
    }

    public static FromWindowContextResult(context: WindowContext<any>, actionType: WindowActionTypes, resultData: any, result: boolean = true, message: string = ""): WindowEvent {

        let event = this.FromWindowContext(context);

        event.ActionType = actionType
        event.Data = resultData;
        event.Result = true;
        event.Message = message;
        event.Result = result;

        return event;

    }

    public static FromWindowContextResultOK(context: WindowContext<any>, actionType: WindowActionTypes, resultData: any): WindowEvent {

        return this.FromWindowContextResult(context, actionType, resultData, true, "");
    }

    public static FromWindowContextResultError(context: WindowContext<any>, actionType: WindowActionTypes, message: string, resultData: any = undefined): WindowEvent {

        return this.FromWindowContextResult(context, actionType, resultData, false, message);
    }
}